import { i18n } from '@/plugins/i18n'

export const instantSettlementStatus = {
    ACTIVE: 1,
    INACTIVE: 0,
};

export const instantSettlementStatusStr = {
    ACTIVE: i18n.t('label.active'),
    INACTIVE: i18n.t('label.inactive'),

    get(status) {
        let status_str = null;

        Object.keys(instantSettlementStatus).forEach(item => {
            if(instantSettlementStatus[item] === status) {
                status_str = instantSettlementStatusStr[item];
            }
        });

        return status_str;
    }
};
